module.exports = __webpack_public_path__ + "files/9e12b3d522579b64281fab6e2b771d3d.png";